import { useSystemVariable } from "./useSystemVariable";

/** The System Variable staff set to close participants' login. */
export const LOGIN_DISABLED_KEY = "is_login_disabled";

/**
 * Whether staff have closed participants' login, read from the server's
 * switch. A value that says true closes it; anything else, or no such
 * variable, leaves it open, as the backend reads it.
 */
export function useIsLoginDisabled() {
  const { data, isLoading } = useSystemVariable(LOGIN_DISABLED_KEY);
  const value = (data?.value ?? "").trim().toLowerCase();
  return {
    isLoginDisabled: ["true", "1", "yes", "on"].includes(value),
    isLoading,
  };
}

export default useIsLoginDisabled;
